import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import { ellipsis } from 'polished'
import contextSportsHeader, {
  SportsHeaderContextType,
} from '@contexts/sportsHeader'
import { HalvesInfoProps } from '@widgets/Teaser/sportsHeader/types'
import { ViewportTypeValues } from '@contexts/viewport'
import { computeTeaserWidth } from '@widgets/Teaser/utils'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'

type StyledHalvesInfoProps = Pick<HalvesInfoProps, 'align'> &
  Pick<SportsHeaderContextType, 'teaserFlex'>

const { SportsHeaderContext } = contextSportsHeader

const StyledHalvesInfo = styled.div<StyledHalvesInfoProps>`
  ${({
    theme: {
      fonts: { goodOT: goodOTFontName },
      colors: { white },
    },
    align,
    teaserFlex,
  }) => {
    let fontSizeDesktop
    let lineHeightDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    const teaserWidthDesktop = computeTeaserWidth({
      flexValue: desktopTeaserFlex,
      viewportType: ViewportTypeValues.DESKTOP,
    })

    if (desktopTeaserFlex === '6') {
      fontSizeDesktop = `${0.02976 * teaserWidthDesktop}px`
      lineHeightDesktop = 1.2
    } else if (desktopTeaserFlex === '4') {
      fontSizeDesktop = `${0.04518 * teaserWidthDesktop}px`
      lineHeightDesktop = 1.2
    } else if (desktopTeaserFlex === '3') {
      fontSizeDesktop = `${0.04878 * teaserWidthDesktop}px`
      lineHeightDesktop = 1.2083
    } else if (desktopTeaserFlex === '2') {
      fontSizeDesktop = `${0.05312 * teaserWidthDesktop}px`
      lineHeightDesktop = 1.17647
    }

    let fontSizeTablet
    let lineHeightTablet
    const tabletTeaserFlex = teaserFlex['tablet']
    const teaserWidthTablet = computeTeaserWidth({
      flexValue: tabletTeaserFlex,
      viewportType: ViewportTypeValues.TABLET,
    })
    if (tabletTeaserFlex === '6') {
      fontSizeTablet = `${0.04518 * teaserWidthTablet}px`
      lineHeightTablet = 1.2
    } else if (tabletTeaserFlex === '3') {
      fontSizeTablet = `${0.04878 * teaserWidthTablet}px`
      lineHeightTablet = 1.2083
    }

    return css`
      flex: 1;
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      font-weight: 500;
      color: ${white};
      text-align: ${align};
      ${ellipsis('100%', 1)};

      ${desktopCSS(css`
        font-size: ${fontSizeDesktop};
        line-height: ${lineHeightDesktop};
      `)}

      ${tabletCSS(css`
        font-size: ${fontSizeTablet};
        line-height: ${lineHeightTablet};
      `)}
      
      ${mobileCSS(css`
        font-size: '5.334vw';
        line-height: 1.2;
      `)}
    `
  }}
`

const HalvesInfo: FunctionComponent<HalvesInfoProps> = ({
  align,
  children,
}) => {
  const { teaserFlex } = useContext(SportsHeaderContext)

  return (
    <StyledHalvesInfo align={align} teaserFlex={teaserFlex}>
      {children}
    </StyledHalvesInfo>
  )
}

export default HalvesInfo
